<div class="bg-white">

    <!-- Filter Bar -->
    <div class="px-6 py-4 border-b border-gray-100 bg-gray-50/50">
        <div class="flex flex-wrap items-end gap-4">

            <!-- Employee Filter -->
            <div class="min-w-[210px]">
                <div class="flex items-center justify-between gap-2 mb-1.5">
                  <label class="block text-xs font-medium text-gray-500">Employee</label>
                  @if(archivedEmployeeCount > 0) {
                  <label class="flex items-center gap-1 text-[10px] font-medium text-gray-500 hover:text-gray-700 cursor-pointer whitespace-nowrap"
                         title="Archived employees are hidden by default">
                    <input type="checkbox" [(ngModel)]="showArchivedEmployees"
                           class="w-3 h-3 text-blue-600 border-gray-300 rounded focus:ring-blue-500 cursor-pointer">
                    Archived ({{ archivedEmployeeCount }})
                  </label>
                  }
                </div>
                <div class="relative">
                    <select [(ngModel)]="selectedEmployeeId" (change)="onFilterChange()"
                        class="w-full appearance-none px-3 py-2 pr-8 rounded-lg text-sm bg-white border border-gray-200
                   focus:ring-2 focus:ring-blue-500/20 focus:border-blue-400 hover:border-gray-300 outline-none cursor-pointer transition-all">
                        <option value="">All employees</option>
                        @for(emp of visibleEmployees; track emp.id) {
                        <option [value]="emp.cognitoId">{{ emp.firstName }} {{ emp.name }}{{ emp.isArchived ? ' (archived)' : '' }}</option>
                        }
                    </select>
                    <svg class="absolute right-2.5 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400 pointer-events-none"
                        fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                    </svg>
                </div>
            </div>

            <!-- Project Filter (multi-select) -->
            <div class="min-w-[220px] project-filter-container">
                <label class="block text-xs font-medium text-gray-500 mb-1.5">Project / Task</label>
                <div class="relative">
                    <!-- Trigger -->
                    <button type="button" (click)="toggleProjectDropdown()"
                        class="w-full flex items-center justify-between gap-2 px-3 py-2 pr-8 rounded-lg text-sm bg-white border border-gray-200
                   focus:ring-2 focus:ring-blue-500/20 focus:border-blue-400 hover:border-gray-300 outline-none cursor-pointer transition-all text-left">
                        @if (selectedProjects.size === 0) {
                        <span class="text-gray-400">All projects</span>
                        } @else {
                        <span class="text-gray-800 truncate">{{ selectedProjects.size }} selected</span>
                        }
                        <svg class="absolute right-2.5 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400 pointer-events-none"
                            fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                        </svg>
                    </button>

                    <!-- Dropdown panel -->
                    @if (projectDropdownOpen) {
                    <div class="absolute z-30 mt-1 w-full min-w-[260px] bg-white border border-gray-200 rounded-lg shadow-lg overflow-hidden">
                        <!-- Search -->
                        <div class="p-2 border-b border-gray-100">
                            <input type="text" [(ngModel)]="projectSearch" placeholder="Search projects…"
                                class="w-full px-2.5 py-1.5 rounded-md text-sm bg-gray-50 border border-gray-200
                       focus:ring-2 focus:ring-blue-500/20 focus:border-blue-400 outline-none" />
                        </div>
                        <!-- Options -->
                        <div class="max-h-60 overflow-y-auto py-1">
                            @for (key of filteredProjectOptions; track key) {
                            <label class="flex items-center gap-2.5 px-3 py-1.5 hover:bg-gray-50 cursor-pointer">
                                <input type="checkbox" [checked]="selectedProjects.has(key)" (change)="toggleProject(key)"
                                    class="w-4 h-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500/30 cursor-pointer" />
                                <span class="text-sm text-gray-700 truncate">{{ resolveKeyName(key) }}</span>
                            </label>
                            } @empty {
                            <p class="px-3 py-2 text-xs text-gray-400">No projects found</p>
                            }
                        </div>
                        <!-- Footer -->
                        @if (selectedProjects.size > 0) {
                        <div class="p-2 border-t border-gray-100">
                            <button type="button" (click)="clearProjectFilter()"
                                class="w-full text-xs font-medium text-gray-500 hover:text-gray-700 py-1 rounded-md hover:bg-gray-50 transition-colors">
                                Clear selection
                            </button>
                        </div>
                        }
                    </div>
                    }
                </div>
            </div>

            <!-- Status Filter -->
            <div class="min-w-[160px]">
                <label class="block text-xs font-medium text-gray-500 mb-1.5">Status</label>
                <div class="relative">
                    <select [(ngModel)]="statusFilter"
                        class="w-full appearance-none px-3 py-2 pr-8 rounded-lg text-sm bg-white border border-gray-200
                   focus:ring-2 focus:ring-blue-500/20 focus:border-blue-400 hover:border-gray-300 outline-none cursor-pointer transition-all">
                        <option value="">All statuses</option>
                         <option value="DRAFT">Draft</option>
                         <option value="APPROVED">Approved</option>
                    </select>
                    <svg class="absolute right-2.5 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400 pointer-events-none"
                        fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                    </svg>
                </div>
            </div>

            <!-- Counts -->
            <div class="flex items-center gap-2 py-2 ml-auto">
                @if (draftCount > 0) {
                <span
                    class="text-xs bg-amber-100 text-amber-700 border border-amber-200 px-2.5 py-1 rounded-lg font-semibold">
                    {{ draftCount }} draft
                </span>
                }
                <span class="text-xs bg-gray-100 text-gray-600 px-2.5 py-1 rounded-lg font-medium">
                    {{ filteredEntries.length }} shown
                </span>
            </div>
        </div>
    </div>

    <!-- Table -->
    @if (loading) {
    <div class="py-16 text-center">
        <div class="w-10 h-10 rounded-full border-4 border-amber-100 border-t-amber-500 animate-spin mx-auto mb-4">
        </div>
        <p class="text-gray-500 text-sm">Loading entries…</p>
    </div>
    } @else {
    <div class="overflow-x-auto">
        <div class="max-h-[600px] overflow-y-auto">
            <table class="w-full text-left">
                <thead class="sticky top-0 z-10 bg-gray-50 border-b border-gray-200">
                    <tr class="text-xs font-semibold text-gray-500 uppercase tracking-wide">
                        <th class="px-6 py-3">Employee</th>
                        <th class="px-4 py-3">Type</th>
                        <th class="px-6 py-3">Project / Task</th>
                        <th class="px-6 py-3">Date</th>
                        <th class="px-6 py-3">Duration</th>
                        <th class="px-4 py-3">Billable</th>
                        <th class="px-4 py-3">Status</th>
                        <th class="px-6 py-3 max-w-xs">Description</th>
                        <th class="px-4 py-3 text-center">Actions</th>
                    </tr>
                </thead>
                <tbody class="divide-y divide-gray-100">
                    @for (entry of filteredEntries; track entry.id) {
                    <tr class="hover:bg-gray-50/50 transition-colors" [class.opacity-50]="processingId === entry.id">

                        <!-- Employee -->
                        <td class="px-6 py-3">
                            <div class="flex items-center gap-2.5">
                                <div class="w-7 h-7 rounded-lg bg-gradient-to-br from-blue-500 to-indigo-600
                            flex items-center justify-center text-white text-xs font-bold flex-shrink-0">
                                    {{ getEmployeeName(entry.employeeId).charAt(0) }}{{
                                    getEmployeeName(entry.employeeId).split(' ')[1]?.charAt(0) || '' }}
                                </div>
                                <span class="text-sm font-medium text-gray-800">{{ getEmployeeName(entry.employeeId)
                                    }}</span>
                            </div>
                        </td>

                        <!-- Type -->
                        <td class="px-4 py-3">
                            @if (getEntryType(entry.projectName) === 'CRM Task') {
                            <span
                                class="inline-flex items-center gap-1 px-2 py-0.5 rounded-md text-xs font-medium bg-purple-50 text-purple-700 border border-purple-100">
                                <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                        d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                                </svg>
                                Task
                            </span>
                            } @else {
                            <span
                                class="inline-flex items-center gap-1 px-2 py-0.5 rounded-md text-xs font-medium bg-blue-50 text-blue-700 border border-blue-100">
                                <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                        d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z" />
                                </svg>
                                Project
                            </span>
                            }
                        </td>

                        <!-- Name -->
                        <td class="px-6 py-3">
                            <span class="text-sm font-medium text-gray-800">{{ getEntryName(entry.projectName) }}</span>
                        </td>

                        <!-- Date -->
                        <td class="px-6 py-3">
                            <div class="text-xs text-gray-600 font-mono">
                                <div>{{ entry.startTime | date:'MMM d' }}</div>
                                <div class="text-gray-400">{{ entry.startTime | date:'HH:mm' }} → {{ entry.endTime |
                                    date:'HH:mm' }}</div>
                            </div>
                        </td>

                        <!-- Duration -->
                        <td class="px-6 py-3">
                            <span class="text-sm font-semibold text-gray-700">{{ getDuration(entry.startTime,
                                entry.endTime) }}</span>
                        </td>

                        <!-- Billable (interactive toggle) -->
                        <td class="px-4 py-3">
                            <button type="button" (click)="toggleBillable(entry)" [disabled]="processingId === entry.id"
                                title="{{ (entry.billable ?? true) ? 'Mark as non-billable' : 'Mark as billable' }}"
                                class="group flex items-center gap-1.5 transition-all cursor-pointer disabled:opacity-40">
                                <!-- pill toggle track -->
                                <span
                                    class="relative inline-flex h-5 w-9 items-center rounded-full transition-colors duration-200"
                                    [class]="(entry.billable ?? true) ? 'bg-emerald-500' : 'bg-gray-200'">
                                    <span
                                        class="inline-block h-3.5 w-3.5 transform rounded-full bg-white shadow-sm transition-transform duration-200"
                                        [class]="(entry.billable ?? true) ? 'translate-x-4' : 'translate-x-1'"></span>
                                </span>
                                <span class="text-xs font-medium"
                                    [class]="(entry.billable ?? true) ? 'text-emerald-700' : 'text-gray-400'">
                                    {{ (entry.billable ?? true) ? 'Yes' : 'No' }}
                                </span>
                            </button>
                        </td>

                        <!-- Approval Status -->
                        <td class="px-4 py-3">
                            @if ((entry.approvalStatus ?? 'DRAFT') === 'APPROVED') {
                            <span class="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold bg-emerald-50 text-emerald-700 border border-emerald-200">
                                <span class="w-1.5 h-1.5 rounded-full bg-emerald-500 flex-shrink-0"></span>
                                Approved
                            </span>
                            } @else {
                            <span class="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold bg-gray-100 text-gray-600 border border-gray-200">
                                <span class="w-1.5 h-1.5 rounded-full bg-gray-400 flex-shrink-0"></span>
                                Draft
                            </span>
                            }
                        </td>

                        <!-- Description -->
                        <td class="px-6 py-3 max-w-xs">
                            @if (entry.content) {
                            <p class="text-xs text-gray-600 line-clamp-2" [title]="entry.content">{{ entry.content }}
                            </p>
                            } @else {
                            <span class="text-xs text-gray-300 italic">No description</span>
                            }
                        </td>

                        <!-- Approve / Set to Draft -->
                        <td class="px-4 py-3 text-center">
                            <div class="flex items-center justify-center gap-1.5">
                                @if ((entry.approvalStatus ?? 'DRAFT') !== 'APPROVED') {
                                <button (click)="approve(entry)" [disabled]="processingId === entry.id" title="Approve"
                                    class="inline-flex items-center gap-1 px-2.5 py-1 rounded-lg text-xs font-medium bg-emerald-50 border border-emerald-200
                         text-emerald-700 hover:bg-emerald-500 hover:text-white hover:border-emerald-500
                         disabled:opacity-40 transition-all cursor-pointer">
                                    <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M5 13l4 4L19 7" />
                                    </svg>
                                    Approve
                                </button>
                                }
                                @if ((entry.approvalStatus ?? 'DRAFT') === 'APPROVED') {
                                <button (click)="setDraft(entry)" [disabled]="processingId === entry.id" title="Set back to draft"
                                    class="inline-flex items-center gap-1 px-2.5 py-1 rounded-lg text-xs font-medium bg-gray-100 border border-gray-200
                         text-gray-600 hover:bg-gray-200 hover:text-gray-800 hover:border-gray-300
                         disabled:opacity-40 transition-all cursor-pointer">
                                    <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                                    </svg>
                                    Set draft
                                </button>
                                }
                            </div>
                        </td>
                    </tr>
                    } @empty {
                    <tr>
                        <td colspan="9" class="px-6 py-16 text-center">
                            <svg class="w-12 h-12 text-gray-300 mx-auto mb-3" fill="none" stroke="currentColor"
                                viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                            <p class="text-gray-500 font-medium">
                                @if (statusFilter === 'DRAFT') { No draft entries — all caught up! }
                                @else { No entries match your filters }
                            </p>
                        </td>
                    </tr>
                    }
                </tbody>
            </table>
        </div>
    </div>
    }
</div>